import { render, staticRenderFns } from "./SliceAccordion.vue?vue&type=template&id=436d2c32&lang=pug&"
import script from "./SliceAccordion.vue?vue&type=script&lang=js&"
export * from "./SliceAccordion.vue?vue&type=script&lang=js&"
import style0 from "./SliceAccordion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports